import { motion, useReducedMotion } from "framer-motion";
import { LANDING_COPY, RETAIN_POINTS, TESTIMONIALS } from "@/data/landingContent";
import { DebriefCard } from "./DebriefCard";

export const WhyItSticks = () => {
  const reduce = useReducedMotion();

  return (
    <>
      <section className="container mx-auto px-5 py-8 md:px-8 md:py-12">
        <div className="grid items-start gap-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-14">
          <div>
            <motion.div
              initial={reduce ? false : { opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.5 }}
            >
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-500">
                {LANDING_COPY.retainEyebrow}
              </p>
              <h2 className="mt-3 max-w-xl text-3xl font-bold tracking-[-0.03em] md:text-4xl">
                {LANDING_COPY.retainTitle}
              </h2>
              <p className="mt-3 max-w-xl text-base text-neutral-500 md:text-lg">{LANDING_COPY.retainSub}</p>
            </motion.div>

            <ol className="mt-10 space-y-6">
              {RETAIN_POINTS.map((point, index) => (
                <motion.li
                  key={point.title}
                  className="flex gap-4"
                  initial={reduce ? false : { opacity: 0, y: 14 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.4, delay: reduce ? 0 : index * 0.07 }}
                >
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-50 text-sm font-bold text-blue-600">
                    {index + 1}
                  </span>
                  <div>
                    <h3 className="text-lg font-semibold text-neutral-900">{point.title}</h3>
                    <p className="mt-1.5 text-[15px] leading-relaxed text-neutral-500">{point.body}</p>
                  </div>
                </motion.li>
              ))}
            </ol>
          </div>

          <motion.div
            initial={reduce ? false : { opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: reduce ? 0 : 0.1 }}
          >
            <DebriefCard />
          </motion.div>
        </div>
      </section>

      <section id="prova" className="container mx-auto scroll-mt-24 px-5 py-16 md:px-8">
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-500">
            {LANDING_COPY.proofEyebrow}
          </p>
          <h2 className="mt-3 max-w-3xl text-3xl font-bold tracking-[-0.03em] md:text-4xl">
            {LANDING_COPY.proofTitle}
          </h2>
        </motion.div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {TESTIMONIALS.map((item, index) => (
            <motion.blockquote
              key={item.name}
              className="landing-card rounded-[20px] border border-neutral-200 bg-white p-6"
              initial={reduce ? false : { opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: reduce ? 0 : index * 0.08 }}
            >
              <p className="text-[16px] leading-relaxed text-neutral-900">“{item.quote}”</p>
              <footer className="mt-5 text-sm text-neutral-500">
                <p className="font-medium text-neutral-900">{item.name}</p>
                <p>{item.meta}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </section>
    </>
  );
};
